import { flatten } from 'lodash';
import { ESCycle } from '~src/interfaces/cycle.interface';

import { Question } from '~src/interfaces/question.interface';
import { ScheduleI } from '~src/interfaces/schedule.interface';
import { Topic } from '~src/interfaces/topic.interface';
import { Survey } from '~src/modules/surveys/interfaces';

import { RichCycle } from './types';
import {Scale} from "~src/interfaces/scale.interface";
import {AttributeI} from "~src/interfaces/attributes.types";

export interface DataState {
  survey?: Survey;
  questions?: Question[];
  topics?: Topic[];
  scales: Scale[];
  attributes: AttributeI[];
  loadingSurvey: boolean;
  loadingScales: boolean;
  loadingAttrs: boolean;
  richCycles: RichCycle[];
}

export function initialDataState(): DataState {
  return {
    scales: [],
    attributes: [],
    loadingSurvey: false,
    loadingScales: false,
    loadingAttrs: false,
    richCycles: [],
  };
}

export enum DataActionTypes {
  get_scales_request = 'get_scales_request',
  get_scales_response = 'get_scales_response',
  get_scales_error = 'get_scales_error',

  get_attributes_request = 'get_attributes_request',
  get_attributes_response = 'get_attributes_response',
  get_attributes_error = 'get_attributes_error',

  get_surveydata_request = 'get_surveydata_request',
  get_surveydata_response = 'get_surveydata_response',
  get_surveydata_error = 'get_surveydata_error',
}

export interface DataActionGetScalesRequest {
  type: DataActionTypes.get_scales_request;
}

export interface DataActionGetScalesResponse {
  type: DataActionTypes.get_scales_response;
  data: Scale[];
}

export interface DataActionGetScalesError {
  type: DataActionTypes.get_scales_error;
}

export interface DataActionGetSurveydataRequest {
  type: DataActionTypes.get_surveydata_request;
}

export interface DataActionGetSurveydataResponse {
  type: DataActionTypes.get_surveydata_response;
  data: {
    survey: Survey;
    topics: Topic[];
    cycles: Record<string, ESCycle[]>;
    schedules: ScheduleI[];
  };

}
export interface DataActionGetSurveydataError {
  type: DataActionTypes.get_surveydata_error,
}

export interface DataActionGetAttributesRequest {
  type: DataActionTypes.get_attributes_request,
}
export interface DataActionGetAttributesResponse {
  type: DataActionTypes.get_attributes_response;
  data: AttributeI[];

}
export interface DataActionGetAttributesError {
  type: DataActionTypes.get_attributes_error;
}

export type DataAction = DataActionGetScalesRequest | DataActionGetScalesResponse | DataActionGetScalesError |
  DataActionGetSurveydataRequest |  DataActionGetSurveydataResponse | DataActionGetSurveydataError |
  DataActionGetAttributesRequest |  DataActionGetAttributesResponse | DataActionGetAttributesError;


export function dataReducer(state: DataState = initialDataState(), action: DataAction): DataState {
  switch (action.type) {
    case DataActionTypes.get_surveydata_request:
      return {
        ...state,
        topics: undefined,
        survey: undefined,
        loadingSurvey: true,
        richCycles: [],
      };
    case DataActionTypes.get_surveydata_response: {
      const responseData = action.data;
      const survey = responseData.survey;
      const schedule = responseData.schedules.find(s => s.surveyId === survey.id)!;
      const cyclesBySurvey = responseData.cycles;
      return {
        ...state,
        topics: responseData.topics,
        questions: flatten(responseData.topics.map(t => t.questions || [])),
        survey,
        loadingSurvey: false,
        richCycles: Object.values(cyclesBySurvey[survey.id]).map(
          cycle => new RichCycle(cycle, schedule, survey),
        ),
      };
    }
    case DataActionTypes.get_surveydata_error:
      return {
        ...state,
        topics: undefined,
        survey: undefined,
        loadingSurvey: false,
      };
    case DataActionTypes.get_scales_request:
      return {
        ...state,
        loadingScales: true,
      };
    case DataActionTypes.get_scales_response:
      return {
        ...state,
        scales: action.data,
        loadingScales: false,
      };
    case DataActionTypes.get_scales_error:
      return {
        ...state,
        loadingScales: false,
      };

    case DataActionTypes.get_attributes_request:
      return {
        ...state,
        loadingAttrs: true,
      };
    case DataActionTypes.get_attributes_response:
      return {
        ...state,
        attributes: action.data,
        loadingAttrs: false,
      };
    case DataActionTypes.get_attributes_error:
      return {
        ...state,
        loadingAttrs: false,
      };
  }

  return state;
}
